import React, { useContext } from 'react';

import { initialValue, useSidebarInternal, SidebarContext } from './UseSidebar';

const Sidebar = React.createContext<SidebarContext>(initialValue);
Sidebar.displayName = 'SidebarContext';

export const useSidebar = () => useContext(Sidebar);

export const SidebarConsumer = Sidebar.Consumer;

export const SidebarProvider: React.FC = ({ children }) => {
  const sidebar = useSidebarInternal();

  return <Sidebar.Provider value={sidebar}>{children}</Sidebar.Provider>;
};
